import React from 'react'

import { faPencilAlt, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from './table.module.scss'

interface Props {
    data: any,
    removeUser: any
    putUser: any
}

export const UserTable: React.FC<Props> = ({ data, removeUser, putUser }) => {

    function changeUserData(usuario: any) {
        putUser(usuario)
    }

    return (
        <React.Fragment>
            <div className={styles.tableContainer}>
                <table className={styles.table}>
                    <thead className={styles.thead}>
                        <tr className={styles.tr1}>
                            <th>Nome</th>
                            <th>Apelido</th>
                            <th>Email</th>
                            <th>Administrador?</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody className={styles.tbody}>
                        {
                            data.map((usuario: {
                                ID: number;
                                CM_NOME: string;
                                CM_NOME_USUARIO: string;
                                CM_EMAIL: string;
                                CM_ADMIN: string;
                            }) => (
                                <tr className={styles.tr} key={usuario.ID}>
                                    <td width="20%">{usuario.CM_NOME}</td>
                                    <td width="20%">{usuario.CM_NOME_USUARIO}</td>
                                    <td width="30%">{usuario.CM_EMAIL}</td>
                                    <td width="25%">{usuario.CM_ADMIN === "S" ? "Sim" : "Não"}</td>
                                    <td>
                                        <div className={styles.actionContainer}>
                                            <button className={styles.pencilBox} onClick={() => changeUserData(usuario)}>
                                                <FontAwesomeIcon icon={faPencilAlt} className="" />
                                            </button>
                                            <button className={styles.trashBox} onClick={() => removeUser(usuario)}>
                                                <FontAwesomeIcon icon={faTrashAlt} className="" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>)
                            )
                        }
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    )
}